/**
 * @desc 财务画像-财务风险分析
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import GroupBox from '../../common/groupBox/GroupBox';
import ExtraInfoTitle from '../../common/extraInfoTitle/ExtraInfoTitle';
import ScorePane from '../common/scorePane/ScorePane';
import { commonRequest, changeAnchor } from '../common/commons';
import Summary from './subComponents/Summary';
import Danger from './subComponents/Danger';
import Template from './subComponents/Template';
import DuPont from './subComponents/DuPont';
import { queryRiskAnalysis } from '../../../services/financialPicture/riskAnalysis';

export default class FinancialRiskAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.nav = [
            { name: '财务风险评分', id: 'risk-score' },
            { name: '财务隐患提示', id: 'risk-danger' },
            { name: '财务风险点提示', id: 'risk-summary' },
            { name: '杜邦分析', id: 'risk-duPont' }
        ];
        this.state = {
            loading: false,
            baseData: {},
            summaryData: {},
            keyValueData: []
        };
    }

    componentDidMount() {
        changeAnchor(this.nav);
        this.getData();
    }

    getData = () => {
        this.setState({
            loading: true
        });

        queryRiskAnalysis(commonRequest()).then(data => {
            data = data || {};
            let { finacialPortraitBasicRiskVO, finacialPortraitRiskStaticsVO, finacialRiskKeyValueVO } = data;

            this.setState({
                baseData: finacialPortraitBasicRiskVO || {},
                summaryData: finacialPortraitRiskStaticsVO || {},
                keyValueData: finacialRiskKeyValueVO || [],
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    render() {
        const { loading, baseData, summaryData, keyValueData } = this.state;
        const { explain, industry, riskTotalScore, riskScoreTypeList } = baseData;

        return (
            <div>

                <GroupBox id="risk-score" title="财务风险评分" explain={explain} industry={industry}>
                    <ScorePane loading={loading} score={riskTotalScore} radarData={riskScoreTypeList}/>
                </GroupBox>

                {/* 财务隐患提示 */}
                <Danger />

                {/* 风险点汇总 */}
                <Summary loading={loading} data={summaryData}/>

                {/* 风险点 */}
                <div>
                    {
                        keyValueData && keyValueData.map(item => (
                            <div key={item.id} id={item.id}>
                                <div className="sub-title">
                                    {item.riskName}
                                    <ExtraInfoTitle riskScore={item.score} explain={item.explain} />
                                </div>
                                {
                                    item.list && item.list.map(subItem => (
                                        <Template key={subItem.abnormalIndex} data={subItem} />
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>

                {/* 杜邦分析 */}
                <DuPont />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/FinancialRiskAnalysis.jsx